import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { Container } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import About from './About';
import AccessibilitySettings from './AccessibilitySettings';
import AccountSettings from './AccountSettings';
import { UserPlaces } from './UserPlaces';

export default function UserMenu() {
  const [searchParams] = useSearchParams();

  const renderTab = () => {
    switch (searchParams.get('tab')?.toLowerCase()) {
      case 'account':
        return <AccountSettings />;
      case 'places':
        return <UserPlaces />;
      case 'accessibility':
        return <AccessibilitySettings />;
      case 'about':
        return <About />;
      default:
        return <AccountSettings />;
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100 pb-3">
      {/* header */}
      <div className="d-none d-lg-block flex-shrink-0">
        <TabsHeader
          options={[
            { option: 'Account' },
            { option: 'Places' },
            { option: 'Accessibility' },
            { option: 'About' },
          ]}
          styles={{ backgroundColor: '#436c98' }}
        />
      </div>
      <div className="d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader
          options={[
            { option: 'Account' },
            { option: 'Places' },
            { option: 'Accessibility' },
            { option: 'About' },
          ]}
          styles={{ backgroundColor: '#436c98' }}
        />
      </div>
      {/* content */}
      <div className="flex-grow-1 overflow-auto min-h-0 px-2 px-md-3 overflow-x-hidden">
        {renderTab()}
      </div>
    </Container>
  );
}
